/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import headerConfig from '@pages/PolicyDetailPage/config/header.config.json';
import loadingConfig from '@pages/PolicyDetailPage/config/loading.config.json';
import errorConfig from '@pages/PolicyDetailPage/config/error.config.json';
import emptyConfig from '@pages/PolicyDetailPage/config/empty.config.json';
import graphConfig from '@pages/PolicyDetailPage/config/weather.analytics.config.json';
import tableConfig from '@pages/PolicyDetailPage/config/activityList.config.json';
import notificationConfig from '@pages/PolicyDetailPage/config/notifications.config.json';
import cancelForm from '@pages/PolicyDetailPage/config/policyCancellation.config.json';
// import { vappContainer } from "@/application";
// import { BreadcrumbService } from "@services/breadcrumbService";

// const getBreadcrumbService = () => {
//   return vappContainer.get<BreadcrumbService>(BreadcrumbService.displayName);
// };

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();

    return {
      header: { ...headerConfig },
      loading: loadingConfig?.loading,
      empty: emptyConfig,
      error: errorConfig,
      graphData: graphConfig,
      tableData: tableConfig,
      notification: notificationConfig,
      cancelPolicy: cancelForm,
    };
  }
}
